export default __webpack_public_path__ + "static/button_download_app-store-05554397cd0d5a9ec528340b0d75518c.svg";